const ROOT = 'dashboard/policies/';

export default {
  arrayList: `${ROOT}list`,
  storeClaim: `${ROOT}store-claim`,
  storeRenewal: `${ROOT}store-renewal`
};
